import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const useRemoveHashFromUrl = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const removeHash = useCallback(() => {
    if (location.hash) {
      navigate(location.pathname + location.search, { replace: true })
    }
  }, [location, navigate])

  return removeHash
}
